import { messaging } from "@/firebaseConfig";
import { getToken, onMessage } from "firebase/messaging";
import { saveFCMToken } from "@/services/notifications";

const VAPID_KEY = "BP_25P9QTvCCKfsoLgsnBEcAqe9_kSxZCfWf1cFNlpTe4J8tQQLUEtSUpNz_vRr3n7s8wpebe1fl-Z2mb_4IKHs"; // Get this from Firebase Console
// const VAPID_KEY =
//   "BHSSquQKgjcrhvWwbdXCLD4--gVywfpsz5DnLGRAeZsuCVP3i20L-6H2lyejswQSe_kOhxR3ZtBVGdPNsBSgY7k";

export async function requestFirebaseNotificationPermission() {
  try {
    const token = await getToken(messaging, { vapidKey: VAPID_KEY });
    if (token) {
      // Guarda el token en localStorage
      localStorage.setItem("fcm_token", token);
      // Subscribe to topic via your backend (see note below)
      await saveFCMToken(token);
      return token;
    }
    throw new Error("No registration token available");
  } catch (err) {
    console.error("FCM permission error:", err);
    return null;
  }
}

export function onFirebaseMessage(callback) {
  onMessage(messaging, callback);
}